import types from '../types'
import Action from '../../types/Action'

const initialState = {
  providerApplication: {
    loading: false,
    error: false,
    success: false,
    data: null as any
  },
  addProviderApplication: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  updateGeneralInfo: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  updateContactInfo: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  updateOrgInfo: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  updateDisclosureQuestions: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  updateApplicationItem: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  updateApplicationCertification: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  submitApplication: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  submitCertification: {
    loading: false,
    error: false,
    success: false,
    data: []
  }
}

const providerApplicationReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case types.GET_PROVIDER_APPLICATION_REQUESTED: {
      return {
        ...state,
        providerApplication: {
          loading: true,
          error: false,
          success: false,
          data: null
        }
      }
    }
    case types.GET_PROVIDER_APPLICATION_FULFILLED: {
      return {
        ...state,
        providerApplication: {
          ...state.providerApplication,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
    case types.GET_PROVIDER_APPLICATION_REJECTED: {
      return {
        ...state,
        providerApplication: {
          ...state.providerApplication,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.ADD_PROVIDER_APPLICATION_REQUESTED: {
      return {
        ...state,
        addProviderApplication: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.ADD_PROVIDER_APPLICATION_FULFILLED: {
      return {
        ...state,
        addProviderApplication: {
          ...state.addProviderApplication,
          loading: false,
          success: true,
          data: action.payload
        },
        providerApplication: {
          ...state.providerApplication,
          data: action.payload
        }
      }
    }
    case types.ADD_PROVIDER_APPLICATION_REJECTED: {
      return {
        ...state,
        addProviderApplication: {
          ...state.addProviderApplication,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_PROVIDER_APPLICATION_GENERAL_INFO_REQUESTED: {
      return {
        ...state,
        updateGeneralInfo: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.UPDATE_PROVIDER_APPLICATION_GENERAL_INFO_FULFILLED: {
      return {
        ...state,
        updateGeneralInfo: {
		      ...state.updateGeneralInfo,
          loading: false,
          success: true,
          data: action.payload
        },
        providerApplication: {
          ...state.providerApplication,
          data: action.payload
        }
      }
    }
	  case types.UPDATE_PROVIDER_APPLICATION_GENERAL_INFO_REJECTED: {
      return {
        ...state,
        updateGeneralInfo: {
		      ...state.updateGeneralInfo,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_PROVIDER_APPLICATION_CONTACT_INFO_REQUESTED: {
      return {
        ...state,
        updateContactInfo: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.UPDATE_PROVIDER_APPLICATION_CONTACT_INFO_FULFILLED: {
      return {
        ...state,
        updateContactInfo: {
		      ...state.updateContactInfo,
          loading: false,
          success: true,
          data: action.payload
        },
        providerApplication: {
          ...state.providerApplication,
          data: action.payload
        }
      }
    }
	  case types.UPDATE_PROVIDER_APPLICATION_CONTACT_INFO_REJECTED: {
      return {
        ...state,
        updateContactInfo: {
		      ...state.updateContactInfo,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_PROVIDER_APPLICATION_ORG_INFO_REQUESTED: {
      return {
        ...state,
        updateOrgInfo: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.UPDATE_PROVIDER_APPLICATION_ORG_INFO_FULFILLED: {
      return {
        ...state,
        updateOrgInfo: {
		      ...state.updateOrgInfo,
          loading: false,
          success: true,
          data: action.payload
        },
        providerApplication: {
          ...state.providerApplication,
          data: action.payload
        }
      }
    }
	  case types.UPDATE_PROVIDER_APPLICATION_ORG_INFO_REJECTED: {
      return {
        ...state,
        updateOrgInfo: {
		      ...state.updateOrgInfo,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_PROVIDER_APPLICATION_DISCLOSURE_QUESTIONS_REQUESTED: {
      return {
        ...state,
        updateDisclosureQuestions: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.UPDATE_PROVIDER_APPLICATION_DISCLOSURE_QUESTIONS_FULFILLED: {
      return {
        ...state,
        updateDisclosureQuestions: {
		      ...state.updateDisclosureQuestions,
          loading: false,
          success: true,
          data: action.payload
        },
        providerApplication: {
          ...state.providerApplication,
          data: action.payload.providerApplication
        }
      }
    }
	  case types.UPDATE_PROVIDER_APPLICATION_DISCLOSURE_QUESTIONS_REJECTED: {
      return {
        ...state,
        updateDisclosureQuestions: {
		      ...state.updateDisclosureQuestions,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_PROVIDER_APPLICATION_ITEM_REQUESTED: {
      return {
        ...state,
        updateApplicationItem: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.UPDATE_PROVIDER_APPLICATION_ITEM_FULFILLED: {
      return {
        ...state,
        updateApplicationItem: {
		      ...state.updateApplicationItem,
          loading: false,
          success: true,
          data: action.payload
        },
        providerApplication: {
          ...state.providerApplication,
          data: action.payload
        }
      }
    }
	  case types.UPDATE_PROVIDER_APPLICATION_ITEM_REJECTED: {
      return {
        ...state,
        updateApplicationItem: {
		      ...state.updateApplicationItem,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_PROVIDER_APPLICATION_CERTIFICATION_REQUESTED: {
      return {
        ...state,
        updateApplicationCertification: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.UPDATE_PROVIDER_APPLICATION_CERTIFICATION_FULFILLED: {
      return {
        ...state,
        updateApplicationCertification: {
		      ...state.updateApplicationCertification,
          loading: false,
          success: true,
          data: action.payload
        },
        providerApplication: {
          ...state.providerApplication,
          data: action.payload
        }
      }
    }
	  case types.UPDATE_PROVIDER_APPLICATION_CERTIFICATION_REJECTED: {
      return {
        ...state,
        updateApplicationCertification: {
		      ...state.updateApplicationCertification,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.SUBMIT_PROVIDER_APPLICATION_REQUESTED: {
      return {
        ...state,
        submitApplication: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.SUBMIT_PROVIDER_APPLICATION_FULFILLED: {
      return {
        ...state,
        submitApplication: {
		      ...state.submitApplication,
          loading: false,
          success: true,
          data: action.payload
        },
        providerApplication: {
          ...state.providerApplication,
          data: action.payload
        }
      }
    }
	  case types.SUBMIT_PROVIDER_APPLICATION_REJECTED: {
      return {
        ...state,
        submitApplication: {
		      ...state.submitApplication,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.SUBMIT_CERTIFICATION_ITEMS_REQUESTED: {
      return {
        ...state,
        submitCertification: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.SUBMIT_CERTIFICATION_ITEMS_FULFILLED: {
      return {
        ...state,
        submitCertification: {
		      ...state.submitCertification,
          loading: false,
          success: true,
          data: action.payload
        },
        providerApplication: {
          ...state.providerApplication,
          data: action.payload
        }
      }
    }
	  case types.SUBMIT_CERTIFICATION_ITEMS_REJECTED: {
      return {
        ...state,
        submitCertification: {
		      ...state.submitCertification,
          loading: false,
          error: action.payload
        }
      }
    }
    default:
      return state
  }
}

export default providerApplicationReducer